import styled from "styled-components";
import { useContext, useEffect, useMemo, useState } from "react";
import ListSizeSetter from "../helperComponents/ListSizeSetter";
import LoadingSection from "../helperComponents/LoadingSection";
import CustomMasonry from "../helperComponents/CustomMasonry";
import CustomPagination from "../helperComponents/CustomPagination";
import { serverLine } from "../../controllers/network/serverLine";
import CustomButton from "../helperComponents/CustomButton";
import LoggedInBoilerplate from "../pages/loggedIn/LoggedInBoilerplate";
import Context from "../../Context";
import PermissionDeniedPage from "./PermissionDeniedPage";
import CustomLabel from "./CustomLabel";
import { BiExport, BiReset } from "react-icons/bi";
import exportFunction from "../../controllers/customControllerForCS/exportFunction";
import MaterialInput from "../helperComponents/MaterialInput";
import CustomLabelDim from "./CustomLabelDim";
import GeneralTableView from "./GeneralTableView";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 25px;
  width: 100%;
  /* margin-top: 30px; */
  padding: 20px;
  border-radius: 10px;
  border: 1px solid var(--borderDim);
  background: var(--surface2);
`;

const Top = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  gap: 10px;
`;

const Filters = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  flex-wrap: wrap;
`;

const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

const SearchContainer = styled.div`
  width: 300px;
`;

const Content = styled.div`
  /* 
  padding: 15px;
  border: 1px solid var(--borderDim);
  background: var(--surface2); 
  */
  //
  //
  border-radius: 10px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: space-between;
  min-height: 500px;
  animation: centerScaleReveal 0.4s ease-in-out forwards;
`;

const BottomPart = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;

  ${({ $columns }) => {
    if ($columns == 1) {
      return `
       flex-direction: column-reverse;
        gap: 15px;
        `;
    }
  }}

  @media (max-width: 900px) {
    flex-direction: column;
    gap: 5px;
  }
`;

export default function ContentList({
  columns = 1,
  userID,
  CardComponent,
  path,
  doReset,
  queryParams,
  filters,
  permissionName,
  title,
  nothingFoundMessage,
  disableFilters,
  inheritedSearchQuery,
  callback,
  onCardClick,
  buttons,
  tableViewSettings,
}) {
  const { loggedInUser } = useContext(Context);
  const [currentPage, setCurrentPage] = useState(0);
  const [maxPages, setMaxPages] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tmpSearch, setTmpSearch] = useState("");
  const [entireResponse, setEntireResponse] = useState({});
  const [searchQuery, setSearchQuery] = useState(null);
  const [totalDocuments, setTotalDocuments] = useState(0);

  const queryParamsMemo = useMemo(
    () => ({
      ...queryParams,
    }),
    [queryParams]
  );

  useEffect(() => {
    console.log("queryParams changed", queryParamsMemo);
    setCurrentPage(0);
    doQuery(0);
  }, [itemsPerPage, queryParamsMemo, searchQuery, inheritedSearchQuery]);

  if (!nothingFoundMessage) nothingFoundMessage = "cette liste est vide"; //This list is empty

  if (!loggedInUser.isSuperAdmin) {
    if (!loggedInUser.role) {
      return <PermissionDeniedPage />;
    }

    if (!loggedInUser.role[permissionName]) {
      return <PermissionDeniedPage />;
    }

    if (!loggedInUser.role[permissionName].includes("VIEW")) {
      return <PermissionDeniedPage />;
    }
  }

  let core = null;

  if (loading) {
    core = <LoadingSection />;
  } else {
    core = (
      <CustomMasonry
        gap="10px"
        list={items.map((item) => (
          <CardComponent
            onCardClick={onCardClick}
            callback={callback}
            entireResponse={entireResponse}
            key={item._id}
            data={item}
          />
        ))}
        maxCol={columns}
        minCol={columns}
      />
    );

    if (tableViewSettings)
      core = (
        <GeneralTableView items={items} fields={tableViewSettings.columns} />
      );

    if (!items.length) {
      core = <CustomLabelDim>{nothingFoundMessage}</CustomLabelDim>;
    }
  }

  let filterComp = (
    <>
      {buttons ? (
        <Filters>
          {buttons
            .filter((btn) => {
              if (!btn.permissionName) return true;
              const perms = loggedInUser.role?.[btn.permissionName] || [];
              return perms.includes("VIEW");
            })
            .map((item) => (
              <CustomButton
                href={item.href}
                onClick={item.onClick}
                icon={item.icon}
              >
                {item.text}
              </CustomButton>
            ))}
        </Filters>
      ) : null}

      <Filters>
        {filters}

        {/* {doReset ? (
          <CustomButton
            onClick={() => {
              setSearchQuery(null);
              doReset();
              setTmpSearch(null);
            }}
            style={{ borderRadius: "10px" }}
            icon={<BiReset />}
          >
            Reset
          </CustomButton>
        ) : null} */}

        {/* <CustomButton
          onClick={doExport}
          style={{ borderRadius: "10px" }}
          icon={<BiExport />}
        >
          Export
        </CustomButton> */}

        <SearchContainer>
          <MaterialInput
            label={"Recherche"}
            value={tmpSearch}
            onTypingEnd={setSearchQuery}
            onEnter={(e) => {
              setSearchQuery(e.target.value);
            }}
            onChange={(e) => {
              setTmpSearch(e.target.value);
            }}
          />
        </SearchContainer>
      </Filters>
    </>
  );

  if (disableFilters) filterComp = null;

  return (
    <Container>
      <CustomLabel>
        {title} {totalDocuments ? `(${totalDocuments})` : null}
      </CustomLabel>

      {filterComp}

      <Content>{core}</Content>

      {loading ? null : (
        <BottomPart $columns={columns}>
          <ListSizeSetter value={itemsPerPage} onChange={setItemsPerPage} />
          <CustomPagination
            value={currentPage}
            max={maxPages}
            onChange={doQuery}
          />
        </BottomPart>
      )}
    </Container>
  );

  function doExport() {
    exportFunction({
      title: "Export",
      path: getThePath(currentPage) + "&forExport=true",
    })();
  }

  function getThePath(newPage) {
    // if (!newPage) newPage = currentPage; this line will cause bug for 0 page

    let more = "";

    let theParams = { ...queryParamsMemo };

    if (userID) theParams.userID = userID;
    if (searchQuery) theParams.searchQuery = searchQuery;
    if (inheritedSearchQuery) theParams.searchQuery = inheritedSearchQuery;

    for (let key in theParams) {
      if (theParams[key]) {
        more = more + `&${key}=${theParams[key]}`;
      }
    }

    let toReturn = `/${path}/?currentPage=${newPage}&itemsPerPage=${itemsPerPage}${more}`;

    if (tableViewSettings) {
      toReturn = toReturn + "&makeFieldsReadable=true&allowID=true";
    }

    return toReturn;
  }

  function doQuery(newPage) {
    let thePath = getThePath(newPage);

    let more = "";
    for (let key in queryParamsMemo) {
      if (queryParamsMemo[key]) {
        more = more + `&${key}=${queryParamsMemo[key]}`;
      }
    }

    setLoading(true);
    setCurrentPage(newPage);
    serverLine.get(thePath).then((newData) => {
      setEntireResponse(newData);
      setLoading(false);
      setItems(newData.list);
      setTotalDocuments(newData.totalDocuments);
      setMaxPages(newData.maxPages);
    });
  }
}
